import React, { useEffect, useState } from 'react';
import { Avatar, Progress } from 'antd';
import './PulseSection.css';
import man from '../../images/detail/man.png';
import woman from '../../images/detail/woman.png';
import JsonRequest from '../../components/jsonRequest';
import { FoodRecognitionComponent } from './FoodRecognitionComponent';

const PulseSection: React.FC<{ data?: any }> = ({ data }) => {
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  const init = async (url: any) => {
    const result = await JsonRequest.rawClient().get(`/common/oss-file-visit-url`, { fileUrl: url })
      .then((resp: any) => resp.json());
    return result?.data;
  };

  useEffect(() => {
    if (data?.generatePictureData?.qwenAnimationUrl) {
      init(data?.generatePictureData?.qwenAnimationUrl).then((url) => {
        setImageUrl(url);
      });
    }
  }, [data]);

  const renderTongueDiagnosis = () => (
    <>
      <div className="pulse-info">
        <span className="pulse-text">舌诊检测报告</span>
        <span className="time-text">{data?.createAt}</span>
      </div>
      <div className="measurement-tag">
        <div className="score-container">
          <Progress
            size={70}
            type="dashboard"
            strokeColor="#94724B"
            format={() => data?.resultData?.parsingResult?.diagnosis?.score || 0}
            className="custom-progress"
            percent={data?.resultData?.parsingResult?.diagnosis?.score}
          />
          <div className="score-text">综合分数</div>
        </div>
      </div>
    </>
  );

  const renderConstitutionDiagnosis = () => (
    <>
      <div className="pulse-info">
        <span className="pulse-text">体质检测报告</span>
        <span className="time-text">{data?.createAt}</span>
      </div>
      <div className="measurement-tag">
        <Avatar src={data?.originalParams?.gender === 'male' ? man : woman} />
      </div>
    </>
  );

  const renderPulseDiagnosis = () => (
    <>
      <div className="pulse-info">
        <span className="pulse-text">脉诊检测报告</span>
        <span className="time-text">{data?.createAt}</span>
      </div>
    </>
  );

  const renderFoodRecognition = () => (
    <FoodRecognitionComponent
      data={data}
      imageUrl={imageUrl}
    />
  );

  return (
    <div className="pulse-section">
      {data?.type === 'TONGUE'
        ? renderTongueDiagnosis()
        : data?.type === 'CORPOREALITY'
          ? renderConstitutionDiagnosis()
          : data?.type === 'FOOD_RECOGNITION'
            ? renderFoodRecognition()
            : renderPulseDiagnosis()}
    </div>
  );
};

export default PulseSection;